import { Box, InputAdornment, TextField, useTheme } from '@mui/material';
import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  COLOR_BLACK_HAZE,
  COLOR_DENIM,
  COLOR_REGENT_ST_BLUE,
  FONT_SIZE_13_PX,
  FONT_SIZE_16_PX,
  FONT_WEIGHT_SEMI_BOLD,
} from '../../popTheme';
import { defineMessages, useIntl } from 'react-intl';

export const SearchBar = ({ handleSetSearchTerm }) => {
  const theme = useTheme();
  const intl = useIntl();
  const messages = defineMessages({
    searchBarButtonLabel: {
      id: 'search.bar.button.label',
      defaultMessage: 'Search Resources',
      description: 'Search bar button label',
    },
  });
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    if (handleSetSearchTerm) {
      handleSetSearchTerm(event.target.value);
    }
  };

  return (
    <Box
      align="right"
      sx={{
        [theme.breakpoints.down('sm')]: {
          mb: '1.25rem',
        },
      }}
    >
      <TextField
        id="search"
        data-testid="resource-search"
        inputProps={{ 'data-testid': 'resource-search-input' }}
        type="search"
        label={searchTerm === '' ? intl.formatMessage(messages.searchBarButtonLabel) : ''}
        size="small"
        value={searchTerm}
        onChange={handleChange}
        sx={{
          [theme.breakpoints.down('sm')]: {
            width: '18rem',
          },
          width: '22.5rem',
          bgcolor: COLOR_BLACK_HAZE,
          '& label.Mui-focused': {
            color: COLOR_REGENT_ST_BLUE,
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: COLOR_REGENT_ST_BLUE,
            },
            '&:hover fieldset': {
              borderColor: COLOR_DENIM,
            },
            '&.Mui-focused fieldset': {
              borderColor: COLOR_REGENT_ST_BLUE,
            },
          },
        }}
        InputLabelProps={{
          shrink: false,
          style: {
            fontSize: { xs: FONT_SIZE_13_PX, sm: FONT_SIZE_16_PX },
            fontWeight: FONT_WEIGHT_SEMI_BOLD,
            color: COLOR_DENIM,
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ color: COLOR_REGENT_ST_BLUE }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
